import React from 'react';
import { browserIsIE } from '../../ie-support';

class LicensePlate extends React.Component {
  render() {
    const { size, plateNumber } = this.props;
    // An equipment identifier is free text of up to 25 characters ("Trukki
    // hallissa 2"), not a 7-character plate, so it has to shrink to fit the
    // same graphic instead of overflowing it.
    const length = (plateNumber || '').length;
    const overflowStyle = length > 8
      ? { fontSize: Math.max(11, Math.round((size === 'large' ? 27 : 20) * 8 / length)) }
      : {};
    return (
      <div
        style={
          size === 'large' ?
          (browserIsIE() ? styles.licensePlateContainerLargeIE : styles.licensePlateContainerLarge) :
          (browserIsIE() ? styles.licensePlateContainerSmall : styles.licensePlateContainerSmall)
        }
      >
        <span
          className='font-roboto-bold'
          style={{
            ...(size === 'large' ? styles.licensePlateTextLarge : styles.licensePlateTextSmall),
            ...overflowStyle,
          }}
        >
          {plateNumber}
        </span>
      </div>
    );
  }
}

const styles = {
  licensePlateContainerLarge: {
    backgroundImage: 'url(/img/vector_plates_1.svg)',
    width: 209,
    height: 54,
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 22,
  },
  licensePlateContainerLargeIE: {
    backgroundImage: 'url(/img/vector_plates_1.svg)',
    width: 139,
    height: 54,
    backgroundSize: 'cover',
    display: 'flex',
    paddingLeft: 22,
  },
  licensePlateContainerSmall: {
    backgroundImage: 'url(/img/vector_plates_1.svg)',
    width: 139,
    height: 36,
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20,
    boxSizing: 'border-box',
    paddingLeft: 15,
  },
  licensePlateTextLarge: {
    color: '#FFFFFF',
    fontSize: 27,
  },
  licensePlateTextSmall: {
    color: '#FFFFFF',
    fontSize: 20,
  },
};

export default LicensePlate;
